// Inbound Requests combo: Originals + Duplicates gradient bars with a cyan area-fill
// Requests line on top. Mirrors calls_receivables_and_payables_combo.js.
import { Chart } from 'chart.js'

import { chartPalette, barDepthFill, verticalGradient } from './palette'

function seriesByLabel(datasets, label) {
    const match = datasets.find((dataset) => dataset.label === label)
    return (match && match.data) || []
}

export function buildInboundRequestsAndDuplicatesCombo(
    canvas,
    optionsFromParam,
    { plugins = [] } = {},
) {
    const { datasets: sourceDatasets = [], labels = [] } = optionsFromParam.data || {}
    const palette = chartPalette()

    const requestsLabel = sourceDatasets[0]?.label
    const originalsLabel = sourceDatasets[1]?.label
    const duplicatesLabel = sourceDatasets[2]?.label

    const requestsCounts = seriesByLabel(sourceDatasets, requestsLabel)
    const originalsCounts = seriesByLabel(sourceDatasets, originalsLabel)
    const duplicatesCounts = seriesByLabel(sourceDatasets, duplicatesLabel)

    const barBase = {
        type: 'bar',
        yAxisID: 'y',
        barPercentage: 0.92,
        categoryPercentage: 0.78,
        borderRadius: { topLeft: 3, topRight: 3, bottomLeft: 0, bottomRight: 0 },
    }

    const datasets = [
        {
            ...barBase,
            label: originalsLabel,
            data: originalsCounts,
            backgroundColor: barDepthFill(palette.green),
            borderColor: palette.green,
            order: 2,
        },
        {
            ...barBase,
            label: duplicatesLabel,
            data: duplicatesCounts,
            backgroundColor: barDepthFill(palette.violet),
            borderColor: palette.violet,
            order: 2,
        },
        {
            type: 'line',
            label: requestsLabel,
            yAxisID: 'y',
            data: requestsCounts,
            borderColor: palette.callsLine,
            backgroundColor: verticalGradient([
                [0, palette.areaFillTop],
                [1, palette.areaFillBottom],
            ]),
            tension: 0.35,
            pointRadius: 0,
            pointHoverRadius: 4,
            pointBackgroundColor: palette.callsLine,
            pointBorderColor: '#fff',
            pointBorderWidth: 1.5,
            borderJoinStyle: 'round',
            fill: true,
            order: 1,
        },
    ]

    return new Chart(canvas, {
        plugins: [...plugins],
        data: { labels, datasets },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            resizeDelay: 0,
            interaction: { mode: 'index', intersect: false },
            plugins: {
                legend: { display: false },
                tooltip: {
                    callbacks: {
                        label: (item) => {
                            const value = Number(item.parsed.y).toLocaleString()
                            return `${item.dataset.label}: ${value}`
                        },
                    },
                },
            },
            scales: {
                x: {
                    stacked: false,
                    grid: { drawTicks: false },
                    ticks: {
                        maxRotation: 0,
                        autoSkip: true,
                        maxTicksLimit: 12,
                    },
                },
                y: {
                    beginAtZero: true,
                    grid: { drawTicks: false },
                    border: { display: false },
                    ticks: { padding: 8 },
                },
            },
            animation: { duration: 320, easing: 'easeOutCubic' },
        },
    })
}
